import { httpCollection } from "us.helper/http/collection";

export default {
  statusList: {
    get: ({ startDate, endDate, statusType }: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationdashboardservice",
            `deliverystatus/summary?fromdate=${startDate}&todate=${endDate}&deliverytype=${statusType}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  statusDetails: {
    get: ({ deliveryDate, statusType, category }: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationdashboardservice",
            `deliverystatus/detail?deliverydate=${deliveryDate}&deliverytype=${statusType}&category=${category}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
